<template>
    <div class="lock-overlay">
        <p>Copeland® Scroll Product Viewer in Portrait Mode.</p>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.lock-overlay {
    display: none;
    position: absolute;
    width: 100vw;
    height: 100vh;
    background-color: #333;
    color: #fff;
    z-index: 10000000;

    @media screen and (max-width: 768px) and (orientation: landscape) {
        display: flex;
        align-items: center;
        justify-items: center;
    }

    p {
        font-size: 1.25rem;
        font-weight: 400;
        text-align: center;
        margin: auto;
    }
}
</style>
